<template>
    <scroll-page :titleArrs="titleArrs" :pageArrs="pageArrs" />
  </template>
  <script>
  export default {
    name: 'Cost',
    data(){
      return{
        pageArrs: [() => import('./Cost/CostOne.vue'), () => import('./Cost/CostTwo.vue')],
        titleArrs: ['项目', 'COOEC']
      }
    }
  }
  </script>